import { render, staticRenderFns } from "./perm.vue?vue&type=template&id=1efacea6"
import script from "./perm.vue?vue&type=script&lang=js"
export * from "./perm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efacea6')) {
      api.createRecord('1efacea6', component.options)
    } else {
      api.reload('1efacea6', component.options)
    }
    module.hot.accept("./perm.vue?vue&type=template&id=1efacea6", function () {
      api.rerender('1efacea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/perm.vue"
export default component.exports